module.exports = __webpack_public_path__ + "static/media/10-15.258bd8f1.mp3";